import { useConfirmDialogStore } from '@/store';
import type { ConfirmDialogProps } from 'primereact/confirmdialog';
import type { ReactNode } from 'react';

export const showConfirmationDialog = (
	message: ReactNode | (() => ReactNode),
	props?: Partial<ConfirmDialogProps>,
) => {
	const { show } = useConfirmDialogStore.getState();

	show(message, props);
};
